import { formatInTimeZone } from 'date-fns-tz'
import { loadStripe } from '@stripe/stripe-js'
import { DotsThreeIcon } from '@phosphor-icons/react'

import { DropdownMenu } from '@/components/ui/dropdown-menu'
import i18n from '@/i18n'

import { chatTypeToIconMap } from '../helpers'
import { renderHeaderIconContainer } from '../ChatSidebar/InboxSelector'

export const chatInboxesTableColumns = (timezone, handleAction) => {
  return [
    {
      Header: i18n.t('chat:table.name'),
      Cell: (data) => {
        const { name, type } = data.row.original
        return (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 15 }}>
            {renderHeaderIconContainer(chatTypeToIconMap[type])}
            <div style={{ fontWeight: 600, fontSize: 14, color: '#333333' }}>{name}</div>
          </div>
        )
      },
    },
    {
      Header: i18n.t('chat:table.phoneNumber'),
      Cell: (data) => {
        const { phone } = data.row.original
        return phone
      },
    },
    {
      Header: i18n.t('chat:table.members'),
      Cell: (data) => {
        const { members } = data.row.original
        // NOTE: we intentionally do not want to show the number of admins
        return members.filter((user) => user.role !== 'Administrator').length
      },
    },
    {
      Header: i18n.t('chat:table.createdAt'),
      Cell: (data) => {
        const { createdAt } = data.row.original
        return `${formatInTimeZone(createdAt, timezone, 'd MMM, yyyy - h:mm a')}`
      },
    },
    {
      Header: '  ',
      Cell: (data) => {
        const original = data.row.original
        const isCustomInbox = original.type === 'CUST'

        return (
          // NOTE: Using `DropdownMenu` to fix the issue of scrollable dropdown within the table of the old UI
          <DropdownMenu
            items={[
              {
                label: i18n.t('chat:table.settings'),
                onClick: () => handleAction({ data: original, mode: 'settings' }),
              },
              {
                label: i18n.t('chat:table.delete'),
                onClick: () => handleAction({ data: original, mode: 'delete' }),
                hidden: !isCustomInbox,
              },
            ]}
            trigger={() => (
              <div
                className="icon-container"
                style={{
                  width: 130,
                  border: '1px solid #EFEFEF',
                  padding: '10px 5px',
                  background: '#FBFBFB',
                  borderRadius: 4,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                  }}
                >
                  <span style={{ marginRight: 10 }}>{i18n.t('chat:table.actions')}</span>
                  <DotsThreeIcon size={20} weight="bold" />
                </div>
              </div>
            )}
          />
        )
      },
    },
  ]
}

export const chatInvoicesTableColumns = (timezone, handleAction) => {
  return [
    {
      Header: i18n.t('chat:table.invoiceDate'),
      Cell: (data) => {
        const { date } = data.row.original
        return `${formatInTimeZone(date, timezone, 'MM/dd/yyyy')}`
      },
    },
    {
      Header: i18n.t('chat:table.paymentMethod'),
      Cell: (data) => {
        return data.row.original.paymentMethod
      },
    },
    {
      Header: i18n.t('chat:table.product'),
      Cell: (data) => {
        return data.row.original.product
      },
    },
    {
      Header: i18n.t('chat:table.inbox'),
      Cell: (data) => {
        return data.row.original.inboxType || '-'
      },
    },
    {
      Header: ' ',
      Cell: (data) => {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              border: '1px solid black',
              borderRadius: 5,
              width: 150,
              marginRight: 40,
              marginLeft: 'auto',
              cursor: 'pointer',
            }}
            onClick={() => handleAction(data.row.original.paymentMethod, data.row.original.pdfUrl)}
          >
            {data.row.original.paymentMethod === 'Invoice'
              ? i18n.t('chat:table.contactTeam')
              : i18n.t('chat:table.download')}
          </div>
        )
      },
    },
  ]
}

export const tooltipInfo = () => (
  <div className="tooltip-container">
    <div className="tooltip-header">{i18n.t('chat:tooltip.title')}</div>
    <div className="tooltip-body">
      <ol>
        <li>{i18n.t('chat:tooltip.step1')}</li>
        <li>{i18n.t('chat:tooltip.step2')}</li>
      </ol>
    </div>
  </div>
)

export const formatRecordTime = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${minutes}:${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}`
}

export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY)
